module.exports = __webpack_public_path__ + "img/resultado-busca.87e769b5.png";